import script from "./EasyModeWithdrawDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./EasyModeWithdrawDialog.vue?vue&type=script&setup=true&lang=ts"

import "./EasyModeWithdrawDialog.vue?vue&type=style&index=0&id=b3979760&scoped=true&lang=css"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3979760"]])

export default __exports__